import { apiClient } from "@/lib/api-client";
import type { LookupProductsResponse } from "@/types/api";

/** Exact batch lookup for the order import: one result per article, in request order. */
export function lookupArticles(articles: string[]) {
  return apiClient.post<LookupProductsResponse>("/products/lookup", { articles });
}
